import { Controller } from '@hotwired/stimulus'
import SignaturePad from 'signature_pad'

const options = { penColor: 'rgb(59, 130, 246)' }

export default class extends Controller<HTMLFormElement> {
  static targets = ['canvas', 'signature', 'comment']

  declare readonly canvasTarget: HTMLCanvasElement
  declare readonly signatureTarget: HTMLInputElement
  declare readonly commentTarget: HTMLTextAreaElement
  declare readonly hasCanvasTarget: boolean
  declare readonly hasSignatureTarget: boolean
  declare readonly hasCommentTarget: boolean

  signaturePad: SignaturePad

  initialize (): void {
    if (this.hasCanvasTarget) {
      this.signaturePad = new SignaturePad(this.canvasTarget, options)
    }
  }

  submit ({ target }: { target: HTMLButtonElement }): void {
    target.disabled = true

    if (this.hasSignatureTarget) {
      if (this.signaturePad.isEmpty()) {
        target.disabled = false
        return alert('Please provide signature and comment.')
      }
      this.signatureTarget.value = this.signaturePad.toDataURL('image/png')
    }

    if (this.hasCommentTarget) {
      const commentValue = this.commentTarget.value.trim()
      if (commentValue === '') {
        target.disabled = false
        return alert('Please provide signature and comment.')
      }
    }

    const event = new CustomEvent('framework-control-signature:submit')
    target.dispatchEvent(event)
  }

  clear (): void {
    if (this.signaturePad !== null && this.signaturePad !== undefined) {
      this.signaturePad.clear()
    }
  }
}
